import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ProjectsSection.css';

const ProjectsSection = () => {
  const projects = [
    {
      id: 1,
      title: 'IoT & CCTV',
      subtitle: 'Hệ thống thông minh',
      description: 'Giải pháp IoT, smart home và hệ thống camera an ninh thông minh',
      link: '/projects/iotcctv',
      image: '/images/IOT-CCTV (2).jpg'
    },
    {
      id: 2,
      title: 'Năng lượng mặt trời',
      subtitle: 'Điện mặt trời',
      description: 'Lắp đặt hệ thống điện mặt trời cho gia đình và doanh nghiệp',
      link: '/projects/solar',
      image: '/images/SOLAPOWER.jpg'
    },
    {
      id: 3,
      title: 'Kiến trúc & Xây dựng',
      subtitle: 'Thiết kế & Thi công',
      description: 'Thiết kế kiến trúc, kết cấu và thi công xây dựng chuyên nghiệp',
      link: '/projects/architecturalconstruction',
      image: '/images/CONTRUCTION.jpg'
    },
    {
      id: 4,
      title: 'Tiểu cảnh sân vườn',
      subtitle: 'Cảnh quan xanh',
      description: 'Thiết kế và thi công sân vườn, tiểu cảnh và cảnh quan xanh',
      link: '/projects/landscapegarden',
      image: '/images/INTERIOR&GADEN.jpg'
    }
  ];

  return (
    <section className="projects-section" id="projects">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">CÁC DỰ ÁN</h2>
          <p className="section-subtitle">Khám phá các lĩnh vực chuyên môn của Phúc An Solutions</p>
        </div>
        
        <div className="projects-grid">
          {projects.map(project => (
            <div className="project-card" key={project.id}>
              <div className="project-image-container">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="project-background"
                />
                <div 
                  className="project-overlay-bg" 
                  style={{ backgroundColor: `${project.color}CC` }}
                ></div>
                <div className="project-icon" style={{ color: project.color }}>
                  {project.icon}
                </div>
              </div>
              
              <div className="project-content">
                <div className="project-header">
                  <h3 className="project-title">{project.title}</h3>
                  <span className="project-subtitle">{project.subtitle}</span>
                </div>
                <p className="project-description">{project.description}</p>
                
                <div className="project-footer">
                  <Link 
                    to={project.link} 
                    className="project-btn"
                    style={{ 
                      backgroundColor: project.color,
                      borderColor: project.color 
                    }}
                  >
                    Khám phá →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="projects-cta">
          <p>Bạn có dự án cần tư vấn?</p>
          <Link to="/contact" className="contact-cta-btn">
            Liên hệ ngay
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection; 